import { INut } from "../../shared/IFood";

const B = 1_000_000_000
const M = 1_000_000
const K = 1_000


export default function FactRow(props:{nut:INut, amount:number}) {
    var amount:number, unit:string
    switch(props.nut.unit){
    case "µg":
        if (props.amount>=B) { amount = props.amount/B; unit = "kg" }
        else if (props.amount>=M) { amount = props.amount/M; unit = "g" }
        else if (props.amount>=K) { amount = props.amount/K; unit = "mg" }
        else { amount = props.amount; unit = props.nut.unit }
        break;
    case "mg":
        if (props.amount>=M) { amount = props.amount/M; unit = "kg" }
        else if (props.amount>=K) { amount = props.amount/K; unit = "g" }
        else { amount = props.amount; unit = props.nut.unit }
        break;
    case "g":
        if (props.amount>=K) { amount = props.amount/M; unit = "g" }
        else { amount = props.amount; unit = props.nut.unit }
        break;
    default:
        amount = props.amount; 
        unit = props.nut.unit
    }
    return <div className="flex between gap-24">
        <label>{props.nut.name}</label>
        <div>{amount.toFixed(3)} {unit}</div>
    </div>
}